var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionType } from '../actions';
export function applyErrorReducer(reducer) { return function (state, action) { if (action.type === ActionType.Failed) {
    return __assign(__assign({}, state), { error: action.error, loading: false });
} return reducer(state, action); }; }
function handleError(error, dispatch) { var normalizedError = error instanceof Error ? error : new Error('Unknown error occurred', { cause: error }); dispatch({ type: ActionType.Failed, error: normalizedError }); }
export function applyErrorHandling(thunk) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var thunkAction = thunk.apply(void 0, args);
    return function (a) { var dispatch = a.dispatch; try {
        var result = thunkAction(a);
        if (result instanceof Promise) {
            return result.catch(function (error) { return handleError(error, dispatch); });
        }
    }
    catch (error) {
        handleError(error, dispatch);
    } return undefined; };
}; }
